import React from 'react';
import './Footer.css';

import BusinessInfo from '../footer-items/business-info';
import HoursInfo from '../footer-items/hours-info';
import SiteNavigation from '../footer-items/site-navigation';
import SocialsInfo from '../footer-items/socials-info';

export default function Footer({ setCurrentUser }) {
  return (
    <>
      <div className='footer-container'>
        <BusinessInfo setCurrentUser={setCurrentUser} />
        <HoursInfo />
        <SiteNavigation />
        <SocialsInfo />
      </div>
    </>
  );
}
